import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Row, Form, Badge, Card, Container } from "react-bootstrap";
import { DatatableWrapper } from "react-bs-datatable";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import Helmet from "react-helmet";
import schoolApi from "../../api/schoolApi";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { useOutletContext } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { SessionContext } from "../SessionProvider";
import { SignalCellularNullTwoTone } from "@material-ui/icons";

const StudentAttendaneReportList = () => {
  const { selectedSessionId, setSelectedSessionId } = useContext(SessionContext);
  
  const navigate = useNavigate();
  const [showCard, setShowCard] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState("");
  const currentYear = new Date().getFullYear();
  // const [datesCounts, setDatasets] = useState("");
  const years = [new Date().getFullYear(), new Date().getFullYear() - 1];
  const [presentAbsentCount, setAttendanceReportCount] = useState({});
  const [studentList, setStudentList] = useState({});
  const [body, setBody] = useState([]);
  const [attendanceReport, setAttendanceReport] = useState([]); //eslint-disable-next-line
  // const [validated, setValidated] = useState(false);
  const [sessionId, setSessionId] = useState({});
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedStudentId, setStudentId] = useState();
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [calendarData, setCalendarData] = useState(false);
  const [attendancePercentage, setAttendancePercentage] = useState();
  const [selectedStudent, setStudent] = useOutletContext();

  useEffect(() => {
    init();
    setBody([]);
  }, [selectedStudent , selectedSessionId]);

  async function init() {
    try {
      if(selectedSessionId && selectedStudent.id){
        setSelectedYear(currentYear);
        console.log("selectedStudent", selectedStudent);
        // let studentDetails = await schoolApi.fetchStudentsById(selectedStudent?.id);
        let studentDetails = await schoolApi.fetchStudentsById(selectedStudent?.id , selectedSessionId);
        // console.log("studentDetails@@=>", studentDetails);
        setStudentList(studentDetails.studentRec ? studentDetails.studentRec : {});

        setAttendanceReport({
          ...attendanceReport,
          sessionid: selectedSessionId,
          studentAdmissionid: studentDetails?.studentRec?.id,
        });
        setCalendarData(false);
      }
    } catch (error) {
      console.log("server-error-->>", error);
      setStudentList(null);
      setAttendanceReport({
        ...attendanceReport,
        sessionid: null,
        studentAdmissionid: null,
      });
      setCalendarData(false);

      if (error?.response?.status === 401) {
        navigate("/login");
      }
      // sarfraj | 26-Feb-2025
      if(!error?.response?.data?.success){
        return toast.error(error?.response?.data?.message);
      }
    }
  }

  const fetchData = async (attendanceReport) => {
    console.log("Attendance-Paremetets-for-Api-->>", attendanceReport);
    const monthName = attendanceReport?.month?.toLowerCase();
    const monthNames = [
      "january",
      "february",
      "march",
      "april",
      "may",
      "june",
      "july",
      "august",
      "september",
      "october",
      "november",
      "december",
    ];
    const monthIndex = monthNames.indexOf(monthName);

    let daysInMonth = 0;
    if (monthIndex >= 0) {
      const year = new Date().getFullYear();
      daysInMonth = new Date(year, monthIndex + 1, 0).getDate();
    }

    try {
      const reports = await schoolApi.studentAttendanceByMonth(attendanceReport);
      console.log("attendance-reports-data-->>", reports);

      if(reports?.success){
        if (reports.attendanceMode === "monthly") {
          console.log("monthName@@@=>", monthName);
          const filteredData = reports?.result?.filter((item) => {
            console.log("item=>", item);
            return item?.month?.toLowerCase() === monthName?.toLowerCase();
          });
  
          console.log("filteredData@@@=>", filteredData);
          if(filteredData && filteredData?.length > 0){
            setShowCard(true);
            setBody(filteredData);
          } else {
            setShowCard(false);
            setBody(filteredData);
            return toast.error("No record found");
          }
        } else {
          const filteredData = Object?.values(reports?.result?.daily_attendance)?.filter(
            (attendance) => attendance.month_name === attendanceReport.month
          );
          console.log('filteredData-->>' , filteredData);
          
          const percentage = (filteredData[0]?.total_present / daysInMonth) * 100;
          setAttendancePercentage(percentage);
          console.log("filteredData122", filteredData);
          setBody(filteredData);
          setAttendanceReportCount((prev) => ({
            ...prev,
            filteredData,
            numberOfDays: daysInMonth,
            total_absent: filteredData[0]?.total_absent,
          }));
          setCalendarData(true);
        }
      }

      // sarfraj | 25-Feb-2025
      if(!reports?.response?.data?.success){
        return toast.error(reports?.response?.data?.message);
      }
      
    } catch (error) {
      console.log("err=>", error);
      setShowCard(false);
      setBody([]);

      if (error?.response?.status === 401) {
        navigate("/login");
      }
    }
  };

  console.log("Final Body Data =>", body);

  const handleSearchClick = () => {
    if (!selectedMonth && selectedMonth === "") {
      toast.error("Please Select Month");
    } else {
      console.log("attendanceReport@!@=>", attendanceReport);
      if (attendanceReport?.length > 0) {
        fetchData(attendanceReport);
      } else if (Object.keys(attendanceReport).length > 0) {
        fetchData(attendanceReport);
      }

      console.log("selectedMonth==>", selectedMonth);
      if (selectedMonth != null) {
        // Add your logic here for when selectedMonth is not null
        // System.out.println("Selected month is: " + selectedMonth);
      } else {
        // Add your logic here for when selectedMonth is null
        // System.out.println("No month is selected.");
      }
    }
  }

  const handleMonthChange = (e) => {
    console.log("month", e.target.value);
    setSelectedMonth(e.target.value);
    setAttendanceReport({
      ...attendanceReport,
      month: e.target.value,
      classid: studentList?.classid,
      // sessionid: selectedStudent.session_id,
      studentAdmissionid: studentList?.id,
    });
    setCalendarData(false);
  };

  const header = [
    {
      title: "Student Name",
      prop: "studentname",
      isFilterable: true,
      cell: (row) => (
        <Link to={"/reports/" + row.id} state={row}>
          {row.name}
        </Link>
      ),
    },
    {
      title: "Attendance Date",
      prop: "attandancedate",
      cell: (row) => moment(row.attandancedate).format("DD-MM-YYYY"),
      isFilterable: true,
    },
    { title: "Present/Absent", prop: "attendancestatus" },
    {
      title: "Created Date",
      prop: "createddate",
      cell: (row) => moment(row.createddate).format("DD-MM-YYYY"),
      isFilterable: true,
    },
    {
      title: "LastModified Date",
      prop: "lastmodifieddate",
      cell: (row) => moment(row.lastmodifieddate).format("DD-MM-YYYY"),
      isFilterable: true,
    },
  ];

  console.log('attendanceReport-->>' , attendanceReport);
  console.log('studentList-->>' , studentList);

  return (
    <Container>
      <Helmet><title>Attendance Report List</title></Helmet>
      {/* <Row className="g-0"> */}
        <Card className="mx-3 custom-card headerOfProject">
          <Row className="g-0">
            <Col lg={10} className="mx-2 text-center">
              <span className="" style={{ fontWeight: "Arial", fontSize: "17px" }}>Student Attendance</span>
            </Col>
          </Row>
        </Card>
       {studentList &&  
        // {/* <Col lg={12}> */}
          body ? (
            <DatatableWrapper
              body={body}
              headers={header}
              paginationOptionsProps={{
                initialState: {
                  rowsPerPage: 10,
                  options: [5, 10, 15, 20],
                },
              }}
            >
              <Row className="mb-4 mx-4">
                <Col lg={2}>
                  <Form.Group className="mx-2 mt-4" controlId="formBasicStatus">
                    <Form.Label className="form-view-label">
                      Class Name
                    </Form.Label>
                    <Form.Control
                      name="classid"
                      value={studentList ? studentList.classname : selectedStudent?.classname}
                      disabled
                    />
                  </Form.Group>
                </Col>
                <Col lg={2}>
                  <Form.Group className="mx-2 mt-4">
                    <Form.Label className="form-view-label">
                      Section Name
                    </Form.Label>
                    <Form.Control
                      name={studentList?.sectionid ? "sectionid" : "section_id"}
                      value={studentList?.section ? studentList?.section : studentList?.section_name}
                      disabled
                    />
                  </Form.Group>
                </Col>
                <Col lg={3}>
                  <Form.Group className="mx-3 mt-4" controlId="formBasicStatus">
                    <Form.Label className="form-view-label">Month</Form.Label>
                    <select
                      required
                      name="month"
                      value={selectedMonth}
                      onChange={handleMonthChange}
                      className="form-select"
                    >
                      <option value="">--Select Month--</option>
                      <option value="January">January</option>
                      <option value="February">February</option>
                      <option value="March">March</option>
                      <option value="April">April</option>
                      <option value="May">May</option>
                      <option value="June">June</option>
                      <option value="July">July</option>
                      <option value="August">August</option>
                      <option value="September">September</option>
                      <option value="October">October</option>
                      <option value="November">November</option>
                      <option value="December">December</option>
                    </select>
                  </Form.Group>
                </Col>
                <Col md={2}>
                  <Button
                    variant="success"
                    style={{ marginTop: "42px" }}
                    onClick={handleSearchClick}
                  >
                    Generate Report
                  </Button>
                </Col>
              </Row>
            </DatatableWrapper>
          ) : (
            ""
          )}

          {calendarData && (
            <>
              {console.log("sgdkjfdgdjfg", calendarData)}
              {console.log("presentAbsentCount@@!12@=>", presentAbsentCount)}
              <Row className="mx-3">
                <Col md={4}>
                  <Link className="text-decoration-none text-reset">
                    <div
                      className="p-2 d-flex flex-column align-items-center m-2"
                      style={{
                        backgroundColor: "white",
                        borderLeft: "4px solid tomato",
                        borderRadius: "8px",
                      }}
                    >
                      <span className="fa-stack small mb-2">
                        <i className="fa-solid fa-circle fa-stack-2x" style={{ color: "tomato" }}></i>
                        <i className="fa-solid fa fa-calendar fa-stack-1x" style={{ color: "white", fontSize: "1.5rem" }}></i>
                      </span>
                      <div className="flex-grow-1 text-center">
                        <h6 className="text-muted mb-1 small">
                          TOTAL LECTURES
                        </h6>
                        <h1
                          className="mb-0 d-inline"
                          style={{ fontSize: "1.5rem" }}
                        >
                          {presentAbsentCount.numberOfDays
                            ? presentAbsentCount.numberOfDays
                            : 0}
                        </h1>
                      </div>
                    </div>
                  </Link>
                </Col>
                <Col md={4}>
                  <Link className="text-decoration-none text-reset">
                    <div
                      className="p-2 d-flex flex-column align-items-center m-2"
                      style={{
                        backgroundColor: "white",
                        borderLeft: "4px solid #1a293b",
                        borderRadius: "8px",
                      }}
                    >
                      <span className="fa-stack small mb-2">
                        <i
                          className="fa-solid fa-circle fa-stack-2x"
                          style={{ color: "green" }}
                        ></i>
                        <i
                          className="fas fa fa-check fa-stack-1x"
                          style={{ color: "white", fontSize: "1.5rem" }}
                        ></i>
                      </span>
                      <div className="flex-grow-1 text-center">
                        <h6 className="text-muted mb-1 small">TOTAL PRESENT</h6>
                        <h1
                          className="mb-0 d-inline"
                          style={{ fontSize: "1.5rem" }}
                        >
                          {presentAbsentCount?.filteredData?.[0]?.total_present
                            ? presentAbsentCount?.filteredData?.[0]
                                ?.total_present
                            : 0}
                        </h1>
                      </div>
                    </div>
                  </Link>
                </Col>
                <Col md={4}>
                  <Link className="text-decoration-none text-reset">
                    <div
                      className="p-2 d-flex flex-column align-items-center m-2"
                      style={{
                        backgroundColor: "white",
                        borderLeft: "4px solid #4798b5",
                        borderRadius: "8px",
                      }}
                    >
                      <span className="fa-stack small mb-2">
                        <i
                          className="fa-solid fa-circle fa-stack-2x "
                          style={{ color: "red" }}
                        ></i>
                        <i
                          className="fa-solid fa fa-close fa-stack-1x"
                          style={{ color: "white", fontSize: "1.5rem" }}
                        ></i>
                      </span>
                      <div className="flex-grow-1 text-center">
                        <h6 className="text-muted mb-1 small">TOTAL ABSENT</h6>
                        <h1
                          className="mb-0 d-inline"
                          style={{ fontSize: "1.5rem" }}
                        >
                          {presentAbsentCount?.total_absent
                            ? presentAbsentCount?.total_absent
                            : 0}
                        </h1>{" "}
                        <Badge bg="light" text="dark" className="small mt-2">
                          {presentAbsentCount.percentageAttendance}
                        </Badge>
                      </div>
                    </div>
                  </Link>
                </Col>
              </Row>
              <Row>
                <Col lg={6}>
                  <div style={{ marginLeft: "40px", marginTop: "13px" }}>
                    {/* <div className="" style={{justifyContent :}}> */}
                    <Calendar
                      activeStartDate={
                        new Date(
                          selectedYear,
                          moment().month(selectedMonth).month(),
                          1
                        )
                      }
                      tileContent={({ date }) => {
                        const formattedDate = moment(date).format("YYYY-MM-DD");

                        // Check if the day is Sunday
                        const dayOfWeek = moment(date).day();
                        if (dayOfWeek === 0) {
                          // 0 = Sunday
                          return null;
                        }

                        const attendanceRecord =
                          presentAbsentCount?.filteredData?.[0]?.attendance.find(
                            (res) => res.attdate === formattedDate
                          );

                        if (attendanceRecord?.status === "present") {
                          return <div className="overlay present-tile" />;
                        } else if (attendanceRecord?.status === "absent") {
                          return <div className="overlay absent-tile" />;
                        }

                        return null;
                      }}
                      value={selectedDate}
                      onClickDay={(value) => setSelectedDate(value)}
                      tileDisabled={({ date }) => moment(date).day() === 0}
                    />
                    {/* value={selectedDate}
                      onClickDay={(value) => {
                      setSelectedDate(value);
                      }}
                    /> */}
                  </div>
                </Col>
                <Col
                  lg={5}
                  style={{ background: "", color: "white", marginTop: "13px" }}
                >
                  <span
                    className=""
                    style={{
                      fontWeight: "Arial",
                      fontSize: "20px",
                      color: "black",
                    }}
                  >
                    Attendance Summary {attendanceReport.month}
                  </span>
                  <Col md={5} style={{ marginTop: "30px", marginLeft: "90px" }}>
                    <CircularProgressbar
                      className="attendance-progress"
                      value={attendancePercentage}
                      text={`${Math.round(
                        attendancePercentage ? attendancePercentage : 0
                      )}%`}
                    />
                  </Col>
                </Col>
              </Row>
            </>
          )}
          {showCard && (
            <>
              {/* <div></div> */}
              {/* <h4 className="mx-4 mt-5 text-center">Monthly Attendance</h4> */}
              {body.map((res) => (
                <Card key={res.id} className="mt-5 mx-4 shadow">
                  <Card.Header className="fw-bold">{res.month}</Card.Header>
                  <Card.Body>
                    <Row>
                      <Col lg={11}>
                        <Card.Title>Total Lectures:</Card.Title>
                      </Col>
                      <Col lg={1}>
                        <Card.Text>{res.total_lectures}</Card.Text>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={11}>
                        <Card.Title>Total Present:</Card.Title>
                      </Col>
                      <Col lg={1}>
                        <Card.Text>{res.total_present}</Card.Text>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={11}>
                        <Card.Title>Total Absent:</Card.Title>
                      </Col>
                      <Col lg={1}>
                        <Card.Text>{res.total_absent}</Card.Text>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              ))}
            </>
          )}
        {/* </Col> */}
        {/* } */}
        <ToastContainer
          position="top-right"
          autoClose={2000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      {/* </Row> */}
    </Container>
  );
};

export default StudentAttendaneReportList;
